import ReactGA from 'react-ga4';
import { useEffect } from 'react';
import { GoogleAnalyticsProps } from './types';
import { env } from '../env';

const GoogleAnalytics = ({
    children,
    anonymiseIp,
    testMode,
    sendPageView,
}: GoogleAnalyticsProps) => {
    useEffect(() => {
        if (ReactGA.isInitialized === false) {
            const trackId = env.REACT_APP_GA_TRACKINGID;
            ReactGA.initialize([{
                trackingId: trackId,
                gaOptions: {
                    anonymizeIp: anonymiseIp,
                    testMode,
                },
            }]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>{ children }</>
    );
};

const trackGAEvent = (label: string, evtCategory = 'dashboard') => {
    ReactGA.event({ action: 'Click', category: evtCategory, label });
};

const trackGAPii = () => {
    const piiFields = document.querySelectorAll<HTMLElement>('[data-pii]');
    const originalData: Record<string, string> = {};
    const redactedData: Record<string, string> = {};

    piiFields.forEach((field) => {
        const key = field.dataset.pii as string;
        const val = field.nodeValue || '[EMPTY]';
        originalData[key] = val;
        redactedData[key] = '[REDACTED]';

        // Only log raw data in dev environments
        // eslint-disable-next-line no-restricted-globals
        if (location.hostname === 'localhost') {
            console.log('Would have sent to Google Analytics (BEFORE redaction):');
            console.table({ originalData });
        }

        // console.log('Sending to Google Analytics (AFTER redaction):');
        // console.table(redactedData);
        // Send redacted data to GA
        ReactGA.send({ hitType: 'event', category: 'form_viewed_sanitized', data: redactedData });
    });
};

const trackGAPageView = () => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
};

export default GoogleAnalytics;
export { trackGAEvent, trackGAPii, trackGAPageView };
